/* Autowaxservice theme JS — cart drawer, predictive search, menu's, accordions. */
(function () {
  const R = (window.AWS && window.AWS.routes) || {};

  /* ---------------- helpers ---------------- */
  const money = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function toast(message, description) {
    const host = $('#aws-toasts');
    if (!host) return;
    const el = document.createElement('div');
    el.className = 'aws-toast';
    el.innerHTML =
      '<p class="font-display font-semibold">' + message + '</p>' +
      (description ? '<p class="text-xs text-muted-foreground mt-0.5">' + description + '</p>' : '');
    host.appendChild(el);
    setTimeout(() => el.remove(), 3500);
  }
  window.awsToast = toast;

  /* ---------------- cart ---------------- */
  const drawer = $('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => drawer.setAttribute('data-open', 'true'));
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    document.body.style.overflow = '';
    setTimeout(() => drawer.classList.add('hidden'), 200);
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
    const body = $('[data-cart-items]');
    const empty = $('[data-cart-empty]');
    const footer = $('[data-cart-footer]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      if (footer) footer.classList.add('hidden');
      return;
    }
    if (empty) empty.classList.add('hidden');
    if (footer) footer.classList.remove('hidden');

    body.innerHTML = cart.items
      .map((item, i) => {
        const img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') + '" alt="' +
            (item.product_title || '').replace(/"/g, '') + '" class="w-16 h-16 object-contain rounded bg-muted flex-shrink-0">'
          : '<div class="w-16 h-16 rounded bg-muted flex-shrink-0"></div>';
        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="text-xs text-muted-foreground">' + item.variant_title + '</p>'
            : '';
        return (
          '<div class="flex gap-3 py-4 border-b border-border" data-line="' + (i + 1) + '">' +
          '<a href="' + item.url + '">' + img + '</a>' +
          '<div class="flex-1 min-w-0">' +
          '<a href="' + item.url + '" class="font-display text-sm font-semibold text-card-foreground line-clamp-2 hover:text-accent transition-colors">' +
          item.product_title + '</a>' + variant +
          '<div class="mt-2 flex items-center justify-between gap-2">' +
          '<div class="flex items-center rounded-md border border-border">' +
          '<button class="p-1.5 text-muted-foreground hover:text-foreground" data-qty="' + (item.quantity - 1) + '" data-line-btn="' + (i + 1) + '" aria-label="Minder">&minus;</button>' +
          '<span class="w-8 text-center text-sm">' + item.quantity + '</span>' +
          '<button class="p-1.5 text-muted-foreground hover:text-foreground" data-qty="' + (item.quantity + 1) + '" data-line-btn="' + (i + 1) + '" aria-label="Meer">+</button>' +
          '</div>' +
          '<span class="font-display text-sm font-bold">' + money(item.final_line_price) + '</span>' +
          '</div></div>' +
          '<button class="self-start p-1 text-muted-foreground hover:text-destructive" data-qty="0" data-line-btn="' + (i + 1) + '" aria-label="Verwijderen">&times;</button>' +
          '</div>'
        );
      })
      .join('');

    const total = $('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  }

  async function refreshCart() {
    const res = await fetch(R.cart + '.js', { headers: { 'Content-Type': 'application/json' } });
    renderCart(await res.json());
  }

  async function addToCart(id, quantity, title) {
    try {
      const res = await fetch(R.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCart();
      toast(window.AWS.strings.added, title || '');
      openDrawer();
    } catch (e) {
      toast(window.AWS.strings.error);
    }
  }

  async function changeLine(line, quantity) {
    const res = await fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
    });
    renderCart(await res.json());
  }

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      const form = add.closest('form[data-product-form]');
      const id = form ? $('[name="id"]', form).value : add.getAttribute('data-variant-id');
      const qtyInput = form ? $('[name="quantity"]', form) : null;
      addToCart(id, qtyInput ? qtyInput.value : 1, add.getAttribute('data-product-title'));
      return;
    }
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
      refreshCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    const lineBtn = e.target.closest('[data-line-btn]');
    if (lineBtn) {
      changeLine(lineBtn.getAttribute('data-line-btn'), lineBtn.getAttribute('data-qty'));
      return;
    }
    /* mobiel menu / accordions */
    const acc = e.target.closest('[data-accordion-trigger]');
    if (acc) {
      const panel = document.getElementById(acc.getAttribute('aria-controls'));
      const isOpen = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', String(!isOpen));
      if (panel) panel.classList.toggle('hidden', isOpen);
      const chev = $('[data-chevron]', acc);
      if (chev) chev.classList.toggle('rotate-180', !isOpen);
      const chevR = $('[data-chevron-right]', acc);
      if (chevR) chevR.classList.toggle('rotate-90', !isOpen);
      return;
    }
    const mm = e.target.closest('[data-mobile-menu-toggle]');
    if (mm) {
      const panel = $('[data-mobile-menu]');
      if (panel) panel.classList.toggle('hidden');
      $$('[data-mobile-menu-toggle] [data-icon-menu]').forEach((i) => i.classList.toggle('hidden'));
      $$('[data-mobile-menu-toggle] [data-icon-close]').forEach((i) => i.classList.toggle('hidden'));
      return;
    }
    const st = e.target.closest('[data-search-toggle]');
    if (st) {
      const bar = $('[data-mobile-search]');
      if (bar) {
        bar.classList.toggle('hidden');
        const input = $('input[type="search"]', bar);
        if (input && !bar.classList.contains('hidden')) input.focus();
      }
      return;
    }
    if (!e.target.closest('[data-search-root]')) {
      $$('[data-search-results]').forEach((el) => el.classList.add('hidden'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------------- predictive search ---------------- */
  function initSearch(root) {
    const input = $('input[type="search"]', root);
    const results = $('[data-search-results]', root);
    if (!input || !results) return;
    let timer;
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        results.classList.add('hidden');
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(async () => {
        try {
          const url =
            R.predictive_search +
            '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
          const res = await fetch(url);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = $('[data-predictive-inner]', doc);
          results.innerHTML = inner ? inner.innerHTML : '';
          results.classList.toggle('hidden', !results.innerHTML.trim());
        } catch (err) {
          results.classList.add('hidden');
        }
      }, 300);
    });
    input.addEventListener('focus', () => {
      if (results.innerHTML.trim()) results.classList.remove('hidden');
    });
  }
  $$('[data-search-root]').forEach(initSearch);

  /* ---------------- product gallery ---------------- */
  $$('[data-gallery]').forEach((gal) => {
    const main = $('[data-gallery-main]', gal);
    $$('[data-gallery-thumb]', gal).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (main) main.src = thumb.getAttribute('data-image');
        $$('[data-gallery-thumb]', gal).forEach((t) => t.classList.remove('ring-2', 'ring-accent'));
        thumb.classList.add('ring-2', 'ring-accent');
      });
    });
  });

  /* ---------------- quantity steppers (product page) ---------------- */
  $$('[data-qty-stepper]').forEach((step) => {
    const input = $('input', step);
    $$('button', step).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const delta = Number(btn.getAttribute('data-delta'));
        const next = Math.max(1, Number(input.value || 1) + delta);
        input.value = next;
      });
    });
  });

  /* ---------------- variant picker ---------------- */
  $$('form[data-product-form]').forEach((form) => {
    const select = $('[data-variant-select]', form);
    if (!select) return;
    select.addEventListener('change', () => {
      const opt = select.options[select.selectedIndex];
      $('[name="id"]', form).value = select.value;
      const priceEl = $('[data-variant-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      const btn = $('[data-add-to-cart]', form);
      if (btn) btn.disabled = opt.dataset.available === 'false';
    });
  });

  refreshCart();
})();
